import React from 'react';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import './styles.css';

const Registration = ({ onSuccess, message }) => {
  return (
    <Box className="verification-box">
    <div className= "container">
      <div className="verification-code">{message}</div>
    </div>
    </Box>
  );
};

Registration.propTypes = {
  onSuccess: PropTypes.func.isRequired,
};

export default Registration;

